import { useIntersection } from '@mantine/hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import UserAvatar from 'src/Components/NavBar/UserAvatar';
import useFetchCommunityFeedItemLikes from 'src/Hooks/Queries/useFetchCommunityFeedItemLikes';

import styles from './LikesListModal.module.scss';
import { Props } from './LikesListModal.props';

const LikesListModal = ({ feedItem }: Props) => {
  const { t } = useTranslation();
  const {
    data: likes,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isError,
  } = useFetchCommunityFeedItemLikes(feedItem.id);

  // Fetch more by scrolling down using Intersection API
  const { ref: loadMoreRef, entry } = useIntersection({ threshold: 0.5 });
  useEffect(() => {
    if (entry?.isIntersecting && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [entry, hasNextPage, isFetchingNextPage, fetchNextPage]);

  const profiles = likes?.pages.flatMap(page =>
    page.items.map(like => (
      <div key={like.id} className={styles.profile}>
        <UserAvatar user={like.from} size={40} />

        <span className={styles.name}>
          {like.from.firstName} {like.from.lastName}
        </span>
      </div>
    ))
  );

  return (
    <div className={styles.container}>
      {profiles}

      {profiles && profiles.length !== 0 ? (
        <div className={styles.statusContainer} ref={loadMoreRef}>
          <p className={styles.statusText}>
            {isFetchingNextPage ? t('common.loading', 'Chargement en cours...') : ''}
          </p>
        </div>
      ) : null}

      {profiles && profiles.length === 0 ? (
        <div className={styles.statusContainer}>
          <p className={styles.statusText}>{t('likes.empty', 'Il n’y a pas de likes.')}</p>
        </div>
      ) : null}

      {isError ? (
        <div className={styles.statusContainer}>
          <p className={styles.statusText}>
            {t('likes.listError', 'Impossible de récupérer les réactions. Reviens plus tard !')}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default LikesListModal;
